import { api } from "../lib/api";
import type { Invoice } from "./invoice";
import type { BankTransaction } from "./transaction";

export interface ReconciliationSuggestion {
  transaction_id: string;
  transaction_date: string;
  transaction_description: string;
  transaction_amount: string;
  invoice_id: string;
  invoice_number: string | null;
  client_name: string;
  invoice_outstanding: string;
  score: number;
  reason: string;
}

export function listReconciliationSuggestions(): Promise<ReconciliationSuggestion[]> {
  return api.get<ReconciliationSuggestion[]>("/api/reconciliation/suggestions");
}

export function acceptReconciliationSuggestion(
  transactionId: string,
  invoiceId: string,
): Promise<Invoice> {
  return api.post<Invoice>("/api/reconciliation/accept", {
    transaction_id: transactionId,
    invoice_id: invoiceId,
  });
}

export interface AllocationInput {
  invoice_id: string;
  amount: string;
}

export interface SetAllocationsResult {
  transaction: BankTransaction;
  allocated_total: string;
  /** Set when the allocations exceed the receipt. A warning, never a refusal — the app
   * already allows overpaying a single invoice. */
  over_allocation_warning: string | null;
}

/** Manual link — the full set of invoices this receipt settles, applied as a diff so
 * untouched allocations keep their payments. An empty list clears it
 * (06-banking-yearend.md § Reconciliation: "manual link/unlink always available"). */
export function setTransactionAllocations(
  transactionId: string,
  allocations: AllocationInput[],
): Promise<SetAllocationsResult> {
  return api.put<SetAllocationsResult>("/api/reconciliation/allocations", {
    transaction_id: transactionId,
    allocations,
  });
}

export function unlinkTransactionInvoice(transactionId: string): Promise<BankTransaction> {
  return api.post<BankTransaction>("/api/reconciliation/unlink", { transaction_id: transactionId });
}
